import {
  Button,
  Grid,
  Paper,
  Autocomplete,
  TextField,
  Tooltip,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Table,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  Input,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import SearchIcon from "@mui/icons-material/Search";
import PushPinIcon from "@mui/icons-material/PushPin";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import Pagination from "base/ui/components/Pagination/pagination";
import { data } from "./mock";
import { Link } from "react-router-dom";
import { ROUTES } from "base/routes/routes";
import { TransitionProps } from "@mui/material/transitions";

const createStockReceiving = () => {
  return observer(() => {
    // mockup data
    const mock = [
      { key: "1", value: "a" },
      { key: "2", value: "b" },
      { key: "3", value: "c" },
      { key: "4", value: "d" },
      { key: "5", value: "e" },
    ];
    // Custom style của form tìm kiếm
    const Style = {
      ".MuiOutlinedInput-root": {
        padding: 0,
      },
      "MuiInputBase-multiline": {
        padding: 0,
      },
      "MuiInputBase-root": {
        padding: 0,
      },
      "MuiTextField-root": {
        padding: 0,
      },
      ".MuiOutlinedInput-input": {
        fontSize: "13px",
      },
      "MuiInputBase-root-MuiOutlinedInput-root": {
        padding: 0,
      },
      ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
    };

    const StyleTb = {
      MuiTableCellRoot: {
        fontSize: "13px",
        fontWeight: 700,
        padding: "5px 10px",
        lineHeight: "20px",
        color: "white",
      },
      borderInherit: {
        borderCollapse: "inherit",
      },
      MuiButtonBaseRoot: {
        color: "white !important",
      },
      MuiTableCellRootTd: {
        fontSize: "13px",
        padding: "5px",
        lineHeight: "20px",
        borderBottom: "unset",
      },
      sticky1: {
        position: "sticky",
        left: 0,
        background: "white",
        zIndex: 5,
      },
      sticky2: {
        position: "sticky",
        left: 45.2,
        background: "white",
        zIndex: 5,
      },
      sticky3: {
        position: "sticky",
        left: 294.5,
        background: "white",
        zIndex: 5,
        color: "#0284c7",
      },

      ".MuiOutlinedInput-root": {
        padding: 0,
      },
      ".MuiOutlinedInput-input": {
        fontSize: "13px",
      },
      ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
    };

    // column render table
    const column = [
      {
        columnName: "STT",
        align: "text-center",
        visible: true,
        sticky: "sticky left-0 bg-primary z-10",
        key: "stt",
      },
      {
        columnName: "Mã nhập phiếu",
        align: "text-center",
        visible: true,
        sticky: "sticky left-[45.2px] min-w-[250.11px]  bg-primary z-10",
      },

      {
        columnName: "Nhà máy",
        align: "text-center",
        visible: false,
      },

      {
        columnName: "Công ty",
        align: "text-center",
        visible: true,
        sticky: "sticky left-[294.5px] bg-primary z-10",
        width: "min-w-[120px]",
        isSoft: true,
        key: "workOrderCode",
      },
      {
        columnName: "Ngày chứng từ",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
        isSoft: true,
        key: "parentWorkOrderCode",
      },
      { columnName: "Người yêu cầu", align: "text-center", visible: true },
      { columnName: "Ghi chú", align: "text-center", visible: true },
      { columnName: "Ngày tạo", align: "text-center", visible: true },
      {
        columnName: "Trạng thái",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
        isSoft: true,
        key: "quantity",
      },
      {
        columnName: "Chức năng",
        align: "text-center",
        visible: true,
        width: "min-w-[120px]",
      },
    ];

    const Transition = React.forwardRef(function Transition(
      props: TransitionProps & {
        children: React.ReactElement<any, any>;
      },
      ref: React.Ref<unknown>
    ) {
      return <Slide direction="up" ref={ref} {...props} />;
    });

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };
    return (
      <>
        <Grid
          container
          spacing={1}
          columns={1}
          direction="column"
          marginY={0.25}
          paddingX={1.5}
        >
          {/* Tiêu Đề và nút thêm mơi */}
          <Grid item>
            <Grid
              container
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid item>
                <h3 className="uppercase font-semibold">Nhập kho</h3>
              </Grid>
              <Grid item>
                <Link to="Create" target="_blank">
                  <Button className="!bg-primary !text-white !normal-case hover:shadow-slate-500 hover:opacity-95 shadow-slate-600 shadow-md transition-all duration-300">
                    <MdAdd fontSize={20} />
                    Thêm mới
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Grid>
          {/* Form Tìm kiếm */}
          <Grid item container justifyContent={"center"} alignItems={"center"}>
            <Paper
              elevation={3}
              className="shadow-sm shadow-stone-400 p-4 flex-1"
            >
              <Grid
                container
                direction={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                columnSpacing={4}
              >
                {/* Bên trái */}
                <Grid
                  item
                  container
                  lg={5}
                  md={6}
                  sm={12}
                  direction={"column"}
                  rowGap={1}
                >
                  {/* Công ty */}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Công ty{" "}
                      </label>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                  {/* Người yêu cầu */}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Người yêu cầu{" "}
                      </label>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                  {/* Mã sản phẩm*/}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Mã sản phẩm
                      </label>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                  {/* Từ ngày*/}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Từ ngày
                      </label>
                      <Tooltip title="Ngày Chứng Từ" placement="top">
                        <HelpIcon className="text-sky-600 mr-1 hover:opacity-95" />
                      </Tooltip>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                  {/* Trạng Thái */}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Trạng Thái
                      </label>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* Bên phải */}
                <Grid
                  item
                  container
                  lg={5}
                  md={6}
                  sm={12}
                  direction={"column"}
                  rowGap={1}
                >
                  {/* Kho*/}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Kho
                      </label>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                  {/* Mã Phiếu Nhập */}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Mã Phiếu Nhập
                      </label>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                  {/* Đến ngày*/}
                  <Grid
                    item
                    container
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    spacing={4}
                  >
                    <Grid item>
                      <label className="text-sm font-semibold tracking-wider">
                        Đến ngày
                      </label>
                      <Tooltip title="Ngày Chứng Từ" placement="top">
                        <HelpIcon className="text-sky-600 mr-1 hover:opacity-95" />
                      </Tooltip>
                    </Grid>
                    <Grid item lg={8}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={mock}
                        sx={Style}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                marginTop={1}
                columnGap={2}
              >
                <Grid
                  item
                  container
                  alignItems={"center"}
                  lg={1.5}
                  direction={"row"}
                >
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={mock}
                    sx={Style}
                    className="flex-1"
                    getOptionLabel={(option) => option.value}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <PushPinIcon
                    onClick={handleClickOpen}
                    className="ml-2 text-sky-600 hover:text-black cursor-pointer"
                  ></PushPinIcon>
                </Grid>
                <Grid item lg={1.5}>
                  <Button
                    type="submit"
                    title="Tìm kiếm"
                    className="!normal-case !text-white !bg-blue-700 !shadow-gray-500 !shadow-md hover:!shadow-sm hover:!shadow-gray-500"
                  >
                    <SearchIcon />
                    Tìm kiếm
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          {/* Table Tìm kiếm */}
          <Grid item container justifyContent={"center"} alignItems={"center"}>
            <Paper
              elevation={3}
              className="shadow-sm shadow-stone-400 p-4 flex-1 overflow-x-auto  "
            >
              <Pagination
                pageCount={10}
                forcePage={1 - 1}
                onPageSizeChange={() => {
                  console.log("handleChangePageSize");
                }}
                onPageChange={() => {
                  console.log("handleChangePageIndex");
                }}
              />
              <TableContainer
                component={Paper}
                className="w-full table-auto space-collapse mb-5 mt-5 text-default !overflow-y-auto !max-h-[500px] flex justify-center"
              >
                <Table>
                  <TableHead className="font-medium text-gray-700 text-default bg-gray-100 !z-10 !sticky !top-0 flex-1">
                    <TableRow>
                      {column?.map((item, index) => {
                        if (item.visible) {
                          return (
                            <TableCell
                              sx={[StyleTb.MuiTableCellRoot]}
                              key={index}
                              align={`${
                                item.align === "text-center"
                                  ? "center"
                                  : "inherit"
                              }`}
                              // onClick={
                              //   item.key === 'parentWorkOrderCode' ||
                              //   item.key === 'workOrderCode' ||
                              //   item.key === 'quantity'
                              //     ? () => {
                              //         handleSortRequest(item.key);
                              //       }
                              //     : () => {}
                              // }
                              scope="col"
                              className={`${item.visible ? "" : "hidden"}
                          ${item.sticky} ${item.width}
                           py-2 px-2 border text-left bg-primary ${item.align}`}
                            >
                              {item.key === "parentWorkOrderCode" ||
                              item.key === "workOrderCode" ||
                              item.key === "quantity" ? (
                                <>
                                  <TableSortLabel
                                    sx={StyleTb.MuiButtonBaseRoot}
                                    active={true}
                                    classes={{ icon: "!text-white" }}
                                  >
                                    {item.columnName}
                                  </TableSortLabel>
                                </>
                              ) : (
                                `${item.columnName}`
                              )}
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.length ? (
                      data?.map((row, index) => (
                        <TableRow key={row.stt} className="hover:!bg-slate-200">
                          {/* Số thứ tự */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {row.stt}
                          </TableCell>
                          {/* Mã nhập phiếu */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            <Link
                              to={`Detail/${row.stt}`}
                              target="_blank"
                              className="text-blue-600 hover:opacity-80"
                            >
                              {row.mnp}
                            </Link>
                          </TableCell>
                          {/* Công ty */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {row.company}
                          </TableCell>
                          {/* Ngày chứng từ */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {row.date}
                          </TableCell>
                          {/* Người yêu cầu */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {row.people}
                          </TableCell>
                          {/* Ghi chú */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {row.note}
                          </TableCell>
                          {/* Ngày tạo */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {row.date}
                          </TableCell>
                          {/* Trạng thái */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {row.status}
                          </TableCell>
                          {/* Chức năng */}
                          <TableCell
                            align="center"
                            sx={[StyleTb.MuiTableCellRootTd]}
                            className="border"
                          >
                            {"Chức năng"}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={100}
                          sx={[StyleTb.MuiTableCellRootTd]}
                          align="center"
                          className="border whitespace-nowrap"
                        >
                          Không tìm thấy dòng nào phù hợp khong
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <span className="block text-default">
                Đang xem {`100`} trong tổng số {`100`} mục
              </span>
            </Paper>
          </Grid>
        </Grid>

        <Dialog
          className={`${open ? "" : "hidden"}`}
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          maxWidth={"md"}
        >
          <DialogTitle className="bg-blue-600 text-center text-white">
            {"LƯU MẪU TÌM KIẾM"}
          </DialogTitle>
          <DialogContent className="overflow-y-hidden block">
            <DialogContentText
              id="alert-dialog-slide-description"
              sx={{
                minWidth: "700px",
                padding: "15px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="mr-2 font-bold text-black">
                Tên mẫu tìm kiếm:{" "}
              </label>
              <TextField
                inputProps={{
                  style: {
                    padding: 6,
                    minWidth: 350,
                    position: "relative",
                  },
                }}
              />
              <div className="absolute right-[121px] top-[79px]">
                <div className="w-0 h-0 border-l-[20px] border-l-transparent border-t-[20px] border-t-gray-200 relative rounded-[3px]">
                  <span className="absolute bottom-0 right-[3px] text-red-600">
                    *
                  </span>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Hủy</Button>
            <Button className="!bg-blue-600 !text-white" onClick={handleClose}>
              Lưu
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  });
};

export default createStockReceiving;
